import { Instagram, Facebook, Linkedin, Youtube, Music2 } from "lucide-react";
import { SITE } from "@/config/site";
import { useSiteSettings } from "@/lib/siteSettings";

/**
 * Social icons row. Prefers admin-configured links (Public Site CMS →
 * Footer & Social); falls back to the compiled SITE.socials so the default
 * appearance is unchanged. Renders only providers that have a real URL.
 */
export default function SocialIcons({ size = 18, showLabels = false, className = "", testid = "social" }) {
  const { social } = useSiteSettings();
  const cfg = social || {};
  const igFallback = SITE.socials.instagram?.url || "";
  const fbFallback = SITE.socials.facebook?.url || "";

  const defs = [
    { id: "instagram", url: cfg.instagram || igFallback, Icon: Instagram, label: "Instagram" },
    { id: "facebook", url: cfg.facebook || fbFallback, Icon: Facebook, label: "Facebook" },
    { id: "linkedin", url: cfg.linkedin || "", Icon: Linkedin, label: "LinkedIn" },
    { id: "youtube", url: cfg.youtube || "", Icon: Youtube, label: "YouTube" },
    { id: "tiktok", url: cfg.tiktok || "", Icon: Music2, label: "TikTok" },
  ];
  const items = defs.filter((d) => d.url);
  if (items.length === 0) return null;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={testid}>
      {items.map(({ id, url, Icon, label }) => (
        <a
          key={id}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`${testid}-${id}`}
          className="inline-flex items-center gap-2 transition-colors hover:text-[color:var(--fl-orange)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--fl-orange)] rounded"
          style={{ color: "var(--fl-text-2)" }}
        >
          <Icon size={size} />
          {showLabels && <span className="text-sm">{label}</span>}
        </a>
      ))}
    </div>
  );
}
